import { Link } from "react-router-dom";
import { useLang } from "../context/LangContext";
import { SITE, waLink } from "../lib/site";
import { Hairline } from "./motion";

export const Footer = () => {
  const { lang, t, path } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-ink-800 border-t border-gold/10">
      <div className="container-lux py-14 md:py-20">
        <Hairline className="mb-14" />
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <div className="font-serif text-2xl text-cream">{SITE.name}</div>
            <div className="overline mt-3">{t.footer.tagline}</div>
            <div className="text-sand text-sm mt-4">{SITE.cedula}</div>
            <p data-testid="footer-legacy" className="text-sand text-[13px] italic leading-relaxed mt-5 max-w-xs">{t.footer.legacy}</p>
          </div>

          <div>
            <div className="label-caps mb-5">{t.footer.nav}</div>
            <ul className="space-y-3 text-sm">
              <li><Link to={path("historia")} className="text-sand hover:text-gold transition-colors">{t.nav.story}</Link></li>
              <li><Link to={path("legado")} className="text-sand hover:text-gold transition-colors">{lang === "pt" ? "Legado" : "Legacy"}</Link></li>
              <li><Link to={path("divorcio")} className="text-sand hover:text-gold transition-colors">{lang === "pt" ? "Divórcio e Separação" : "Divorce & Separation"}</Link></li>
              <li><Link to={path("alimentos")} className="text-sand hover:text-gold transition-colors">{lang === "pt" ? "Pensões de Alimentos" : "Child & Spousal Support"}</Link></li>
              <li><Link to={path("patrimonio")} className="text-sand hover:text-gold transition-colors">{lang === "pt" ? "União de Facto e Património" : "Cohabitation & Assets"}</Link></li>
              <li><Link to={path("consulta")} className="text-sand hover:text-gold transition-colors">{lang === "pt" ? "Consulta Online" : "Online Consultation"}</Link></li>
              <li><Link to={path("internacional")} className="text-sand hover:text-gold transition-colors">{lang === "pt" ? "Direito Internacional" : "International Law"}</Link></li>
              <li><Link to={path("vistos")} className="text-sand hover:text-gold transition-colors">{lang === "pt" ? "Vistos e Residência" : "Visas & Residency"}</Link></li>
              <li><Link to={path("guia")} className="text-sand hover:text-gold transition-colors">{t.nav.guide}</Link></li>
              <li><Link to={path("privacidade")} className="text-sand hover:text-gold transition-colors">{t.footer.privacy}</Link></li>
            </ul>
          </div>

          <div>
            <div className="label-caps mb-5">{t.footer.contactHeading}</div>
            <ul className="space-y-3 text-sm">
              <li className="text-sand">{SITE.office}</li>
              <li><a href={`mailto:${SITE.email}`} className="text-sand hover:text-gold transition-colors">{SITE.email}</a></li>
              <li><a href={SITE.phoneHref} data-testid="footer-phone" className="text-sand hover:text-gold transition-colors">{SITE.whatsapp}</a></li>
              <li><a href={waLink(lang)} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="text-sand hover:text-gold transition-colors">WhatsApp</a></li>
            </ul>
          </div>
        </div>

        <p className="text-xs text-sand/50 leading-relaxed mt-12 max-w-3xl border-t border-gold/10 pt-8">
          {t.contact.disclaimer}
        </p>
        <div className="flex flex-wrap items-center justify-between gap-4 mt-6">
          <span className="text-xs text-sand/40">© {new Date().getFullYear()} {SITE.name}. {t.footer.rights}</span>
          <span className="text-xs text-sand/40">{SITE.domain}</span>
        </div>
      </div>
    </footer>
  );
};
